{{ 'Dashboard::AgentPerformanceReportFailedMessage' | abpLocalization }}